// Shared, framework-free helpers for the redesigned EMA/Kareo chart modals
// (Send to Chart and Create New Chart). Each modal computes its own list of
// still-missing required fields (the rules differ — tasks/authorization vs
// insurance/gender) and renders an identical footer prompt from it.

// "a", "a and b", or "a, b, and c" — Oxford-comma join for the missing-field summary.
export const joinWithAnd = (items) => {
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
};

// Footer "what's left" prompt for a disabled Submit. `closing` is the trailing
// clause (e.g. 'to send.' or 'to continue.'). Returns null when nothing is missing.
export const buildMissingMessage = (items, closing) => {
  if (!items || items.length === 0) return null;
  return `Add ${joinWithAnd(items)} ${closing}`;
};

// A chart modal's form can outlive its turn on screen: Next/Previous Record swaps it
// for the next record's (reducers/modal) while its submit is still in flight, and that
// submit calls hideModal when it finishes. Bind each form's hideModal to the modal it
// was opened as, so a late callback can't close the form that replaced it.
export const hideOwnModalOnly = (ownModal, getOpenModal, hideModal) => () => {
  if (getOpenModal() === ownModal) hideModal();
};
